/**
 * OfflineCard — replaces scan results when navigator.onLine is false.
 * Auto-dismisses + reinitializes when 'online' event fires.
 */
import { useEffect } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineCard({ onReconnect }) {
  useEffect(() => {
    const handler = () => {
      onReconnect?.();
    };
    window.addEventListener("online", handler, { once: true });
    return () => window.removeEventListener("online", handler);
  }, [onReconnect]);

  return (
    <div
      data-testid="offline-card"
      role="status"
      aria-live="polite"
      style={{
        background: "#FFFFFF",
        border: "1px solid #E2E0DC",
        borderRadius: 16,
        padding: 20,
        textAlign: "center",
      }}
    >
      <WifiOff size={32} color="#8E8A84" style={{ margin: "0 auto" }} strokeWidth={1.6} />
      <div
        className="font-barlow-cond"
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: "#1A1A1A",
          marginTop: 12,
        }}
      >
        No internet connection
      </div>
      <div
        style={{
          fontFamily: "Manrope",
          fontSize: 14,
          fontWeight: 400,
          color: "#6B6760",
          marginTop: 8,
        }}
      >
        Connect to the internet to scan food.
      </div>
    </div>
  );
}
